// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";

// export default function AddToCartButton({
//   courseId,
//   levelId,
//   levelbadge,
//   courseTitle,
//   amount,
//   mode, // "full", "partial"
//   children,
//   className = "",
// }) {
//   const [loading, setLoading] = useState(false);
//   const [existsInCart, setExistsInCart] = useState(false);
//   const [cartMode, setCartMode] = useState(null);

//   const navigate = useNavigate();
//   const user = JSON.parse(localStorage.getItem("user"));

//   const fetchCartStatus = useCallback(async () => {
//     if (!user) return;
//     try {
//       const res = await fetch(`https://agepcoatings.com/payments/getcart/${user.uid}`);
//       const data = await res.json();
//       if (data.success && data.items) {
//         const item = data.items.find(
//           (i) => i.courseId === courseId && i.levelId === levelId
//         );
//         if (item) {
//           setExistsInCart(true);
//           setCartMode(item.mode);
//         } else {
//           setExistsInCart(false);
//           setCartMode(null);
//         }
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   }, [courseId, levelId, user]);

//   useEffect(() => {
//     fetchCartStatus();
//   }, [fetchCartStatus]);

//   const handleAddToCart = async () => {
//     if (!user) return alert("Please login first!");
//     if (existsInCart) return alert("This course is already in your cart");

//     setLoading(true);
//     try {
//       const payload = {
//         uid: user.uid,
//         courseId,
//         levelId,
//         levelbadge,
//         courseTitle,
//         amount: Number(amount),
//         mode,

//       };

//       const res = await fetch("https://agepcoatings.com/payments/addtocart", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });
//       const data = await res.json();
//       if (!data.success) return alert(data.message || "Failed to add to cart");

//       alert(
//         `✅ "${courseTitle}" added to cart (${
//           mode === "partial" ? "Reserved" : "Enrolled"
//         })`
//       );

//       // Navigate to CartPage after adding
//       navigate("/addtocart");
//     } catch (err) {
//       console.error(err);
//       alert("Something went wrong!");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <span
//       className={className}
//       disabled={loading || existsInCart}
//       onClick={handleAddToCart}
//     >
//       {loading
//         ? "Processing..."
//         : existsInCart
//         ? cartMode === "partial"
//           ? "Reserved (25% Paid)"
//           : "Enrolled"
//         : children}
//     </span>
//   );
// }

// Profile Page incomplate alert showing
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";

export default function AddToCartButton({
  courseId,
  levelId,
  levelbadge,
  courseTitle,
  amount,
  mode, // "full", "partial", "remaining"
  children,
  currency = "USD",
  className = "",
  onClick, // ✅ allow parent control (EnrollButton, Payremaning, ReservedLink)
}) {
  const [loading, setLoading] = useState(false);
  const [existsInCart, setExistsInCart] = useState(false);
  const [cartMode, setCartMode] = useState(null);

  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));

  const fetchCartStatus = useCallback(async () => {
    if (!user) return;
    try {
      const res = await fetch(
        `https://agepcoatings.com/payments/getcart/${user.uid}`
      );
      const data = await res.json();
      if (data.success && data.items) {
        const item = data.items.find(
          (i) => i.courseId === courseId && i.levelId === levelId
        );
        if (item) {
          setExistsInCart(true);
          setCartMode(item.mode);
        } else {
          setExistsInCart(false);
          setCartMode(null);
        }
      }
    } catch (err) {
      console.error(err);
    }
  }, [courseId, levelId, user]);

  useEffect(() => {
    fetchCartStatus();
  }, [fetchCartStatus]);

  const handleAddToCart = async (e) => {
    // ✅ first let parent intercept
    if (onClick) {
      onClick(e);
      if (e.defaultPrevented) {
        // 🚫 parent blocked, stop here
        return;
      }
    }

    if (!user) return alert("Please login first!");
    if (existsInCart) return alert("This course is already in your cart");

    setLoading(true);

    try {
      const payload = {
        uid: user.uid,
        courseId,
        levelId,
        levelbadge,
        courseTitle,
        amount: Number(amount),
        mode,
        currency,
      };

      console.log(payload);

      const res = await fetch("https://agepcoatings.com/payments/addtocart", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (!data.success) return alert(data.message || "Failed to add to cart");
      console.log(data);

      alert(
        `✅ "${courseTitle}" added to cart (${
          mode === "partial" ? "Reserved" : "Enrolled"
        })`
      );

      navigate("/addtocart");
    } catch (err) {
      console.error(err);
      alert("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <span
      className={className}
      disabled={loading || existsInCart}
      onClick={handleAddToCart}
    >
      {loading
        ? "Processing..."
        : existsInCart
        ? cartMode === "partial"
          ? "Reserved (25% Paid)"
          : "Enrolled"
        : children}
    </span>
  );
}

// Rediract to profile if incomplate profile to rediract to addtocart page
// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";

// export default function AddToCartButton({
//   courseId,
//   levelId,
//   levelbadge,
//   courseTitle,
//   amount,
//   mode, // "full", "partial", "remaining"
//   children,
//   className = "",
//   disabled, // 👈 from parent
// }) {
//   const [loading, setLoading] = useState(false);
//   const [existsInCart, setExistsInCart] = useState(false);
//   const [cartMode, setCartMode] = useState(null);

//   const navigate = useNavigate();
//   const user = JSON.parse(localStorage.getItem("user"));

//   const fetchCartStatus = useCallback(async () => {
//     if (!user) return;
//     try {
//       const res = await fetch(
//         `https://agepcoatings.com/payments/getcart/${user.uid}`
//       );
//       const data = await res.json();
//       if (data.success && data.items) {
//         const item = data.items.find(
//           (i) => i.courseId === courseId && i.levelId === levelId
//         );
//         if (item) {
//           setExistsInCart(true);
//           setCartMode(item.mode);
//         } else {
//           setExistsInCart(false);
//           setCartMode(null);
//         }
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   }, [courseId, levelId, user]);

//   useEffect(() => {
//     fetchCartStatus();
//   }, [fetchCartStatus]);

//   const handleAddToCart = async () => {
//     if (!user) return alert("Please login first!");

//     // 🚫 Profile incomplete → go to profile page
//     if (disabled) {
//       alert("Please complete your profile first!");
//       navigate("/profile", {
//         state: {
//           redirectAfterProfile: {
//             courseId,
//             levelId,
//             levelbadge,
//             courseTitle,
//             amount,
//             mode,
//           },
//         },
//       });
//       return;
//     }

//     if (existsInCart) return alert("This course is already in your cart");

//     setLoading(true);
//     try {
//       const payload = {
//         uid: user.uid,
//         courseId,
//         levelId,
//         levelbadge,
//         courseTitle,
//         amount: Number(amount),
//         mode,
//       };

//       const res = await fetch("https://agepcoatings.com/payments/addtocart", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });
//       const data = await res.json();
//       if (!data.success) return alert(data.message || "Failed to add to cart");

//       alert(
//         `✅ "${courseTitle}" added to cart (${
//           mode === "partial"
//             ? "Reserved"
//             : mode === "remaining"
//             ? "Pay Remaining"
//             : "Enrolled"
//         })`
//       );

//       navigate("/addtocart"); // ✅ go cart only if profile complete
//     } catch (err) {
//       console.error(err);
//       alert("Something went wrong!");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <span
//       className={className}
//       disabled={loading || existsInCart}
//       onClick={handleAddToCart}
//       style={{ cursor: disabled ? "not-allowed" : "pointer" }}
//     >
//       {loading
//         ? "Processing..."
//         : existsInCart
//         ? cartMode === "partial"
//           ? "Reserved (25% Paid)"
//           : "Enrolled"
//         : children}
//     </span>
//   );
// }
